import React from "react";
import styled, {keyframes} from "styled-components";
import { useMedia } from "../../hooks/useMedia";
// Assets
import BannerDesktop from "../../assets/img/main-banner/banner-principal-desktop.jpg";
import BannerMobile from "../../assets/img/main-banner/banner-principal-mobile.jpg";

export default function FullBanner() {
  const isMobile = useMedia('(max-width: 650px)');

  return (  
    <Wrapper id="home">
      <img 
        src={isMobile ? BannerMobile : BannerDesktop}
        alt="banner principal de chaves"  
      />
    </Wrapper>
  );
}

const zoomAnimation = keyframes`
  0% {
    transform: scale(1); 
  }
  100% {
    transform: scale(1.1);
  }
`;
const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  display: flex;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
    animation: ${zoomAnimation} 8s infinite alternate ease-in-out; 
  }
`;


